import React from "react";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "ui/components/form";
import { Checkbox } from "ui/components/checkbox";
import { Slider } from "ui/components/slider";
import { RATING_GUIDE } from "@/modules/performance/components/rating-guide";

export const RatingItem = ({ control, name, label, description, disabled }) => {
  return (
    <div className="border rounded-md p-4 space-y-4">
      <FormField
        control={control}
        name={name}
        render={({ field }) => (
          <FormItem>
            <div className="flex items-start justify-between gap-2">
              <div>
                <div className="text-base font-medium">{label}</div>
                <p className="text-sm text-gray-500 max-w-3xl whitespace-pre-wrap">
                  {description}
                </p>
              </div>
              <label className="flex items-center gap-2 text-sm text-muted-foreground">
                <Checkbox
                  checked={(field.value ?? 0) === 0}
                  onCheckedChange={(v) => field.onChange(v ? 0 : 1)}
                  disabled={disabled}
                />
                Not Observed
              </label>
            </div>
            <FormLabel className="sr-only">{label} rating</FormLabel>
            <FormControl>
              <div>
                <div className="flex justify-between text-xs text-muted-foreground mb-2">
                  {RATING_GUIDE.map((s) => (
                    <span
                      key={s.value}
                      className={`w-12 text-center flex flex-col ${!disabled ? "cursor-pointer" : ""}`}
                      onClick={() => {
                        if (!disabled) {
                          field.onChange(s.value);
                        }
                      }}
                    >
                      <span className="text-xl text-muted-foreground">
                        {s.emoji}
                      </span>
                      <span className="text-xs text-muted-foreground">
                        {s.label}
                      </span>
                    </span>
                  ))}
                </div>
                <Slider
                  value={[field.value ?? 1]}
                  min={1}
                  max={7}
                  step={1}
                  onValueChange={(v) => field.onChange(v?.[0] ?? 0)}
                  sliderClassName="bg-chart-2"
                  disabled={disabled}
                />
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
